import { DocumentContentSection } from "../DocumentContentSection";
import { DocumentSignature } from "../DocumentSignature";
import { DocumentTitle } from "../DocumentTitle";

export const PrivacyPolicy = () => {
  return (
    <div className="w-full min-h-screen bg-white">
      <div className="flex flex-col min-h-[calc(100vh-72px)] p-4 sm:px-8">
        <div className="flex flex-col gap-6">
          <DocumentTitle title="プライバシーポリシー" releaseDate="2025年 3月 10日" lastUpdated="2025年 3月 10日" />
          <div className="text-sm leading-7">
            <p className="mb-8">
              株式会社Masentic(以下「当社」といいます。)は、当社が提供するサービス「サンバ」(以下「本サービス」といいます。)をご利用いただくユーザーの皆様のプライバシーを尊重し、個人情報の適切な管理と保護に努めます。本ポリシーは、本サービスにおける個人情報の適正な取得・利用・提供をし、保護するためのものです。
            </p>
            <DocumentContentSection title="1. 個人情報の取得">
              <p className="mb-6">
                当社は、本サービスの運営や各種機能の提供に必要な範囲で、以下を含む個人情報を公正かつ適切な方法で取得します。
              </p>
              <ul className="list-disc pl-6 mb-6">
                <li>氏名および年齢</li>
                <li>メールアドレスおよび電話番号</li>
                <li>IPアドレス</li>
                <li>デバイス情報(端末識別子等)、広告識別子およびCookie等を利用して取得する情報</li>
                <li>広告ID</li>
                <li>決済情報(ポイント換金や手数料の支払い等に必要な情報を含みます。)</li>
                <li>
                  SNSその他第三者提供サービスのアカウントとの連携機能を利用する場合の当該外部サービスのアカウントに関連する情報
                </li>
                <li>その他上記の各情報に関連する情報</li>
              </ul>
              <p className="mb-8">
                これらは、ユーザーが会員登録を行う際や本サービス内での各種取引・手続を利用する際に、ユーザーの意思に基づいてご提供いただくものです。
              </p>
            </DocumentContentSection>

            <DocumentContentSection title="2. 個人情報の利用目的">
              <p className="mb-4">当社は、取得したユーザーの個人情報を以下の目的で利用します。</p>
              <ul className="list-disc pl-6 mb-8">
                <li>本サービスの運営・提供のため</li>
                <li>ユーザー登録、ログイン、各種機能の提供、ポイントの管理などのため</li>
                <li>
                  本サービスに関する広告･宣伝・販売促進活動(電子メールやダイレクトメール等による、商品、サービス、各種イベントのご案内を含む)のため
                </li>
                <li>円滑なサービス提供・サポートのため</li>
                <li>ユーザーからのお問い合わせ対応、重要なお知らせや障害情報の通知のため</li>
                <li>適切なセキュリティ確保のため</li>
                <li>不正アクセスや不正利用の防止、利用状況の確認のため</li>
                <li>本人確認のため</li>
                <li>データ分析・サービス改善のため</li>
                <li>個人を特定できない形に加工したデータを用いた統計解析・サービス品質向上のため</li>
              </ul>
            </DocumentContentSection>

            <DocumentContentSection title="3. 個人情報の提供">
              <p>
                (1)
                当社は、以下の提供先に対して、ユーザーの個人情報を、書面または電磁的な方法により提供します。その際、提供される情報は必要最小限に限定されます。ユーザーに無断で外部事業者に個人情報を販売することはありません。
              </p>
              <div className="mb-8">
                <p>＜提供先＞</p>
                <p className="mb-4">マーケティング活動に用いるため</p>

                <p>＜提供目的＞</p>
                <p className="mb-4">ユーザーに対する特典の提供のため</p>

                <p>＜提供する個人情報＞</p>
                <p className="mb-4">・電話番号</p>
              </div>
              <p>
                (2)
                前項にかかわらず、以下の場合については、正当な事由がある場合として、あらかじめ本人の同意を得ることなく個人情報を第三者に提供することがあります。
              </p>
              <p>① 法令に基づく場合</p>
              <p>
                ② 人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき
              </p>
              <p>
                ③
                公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき
              </p>
              <p className="mb-8">
                ④
                国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
              </p>
            </DocumentContentSection>

            <DocumentContentSection title="4. データの保存期間と管理">
              <p className="mb-8">
                当社は、収集した個人情報を、その利用目的を達成するために必要な期間、または法令で定められた期間のみ保管します。
                ユーザーは、個人情報の確認・更新・削除を希望する場合、カスタマーサポートへご連絡いただくことで対応を受けることができます。当社は、適用法令に基づき、合理的な期間内に必要な措置を講じます。
              </p>
            </DocumentContentSection>

            <DocumentContentSection title="5. セキュリティ対策">
              <p className="mb-8">
                当社は、暗号化技術や安全な取引システムを導入するなど、ユーザーの個人情報を保護するために合理的なセキュリティ対策を講じています。しかしながら、完全な安全性を保証するものではありません。ユーザー自身も、アカウント情報(ID・パスワード等)を安全に管理し、不正利用を防止する責任を負います。
              </p>
            </DocumentContentSection>

            <DocumentContentSection title="6. ユーザーの権利">
              <p className="mb-6">ユーザーは、当社が保有する個人情報について、以下の権利を有します。</p>
              <ul className="list-disc pl-6">
                <li>個人情報の閲覧、追加、修正</li>
                <li>個人情報の利用の停止、削除要請</li>
                <li>データの処理制限や異議申し立て</li>
              </ul>
              <p className="mb-6">
                個人情報に関するお問い合わせは、カスタマーサポートまでご連絡ください。適用法令に基づき、適切に対応いたします。
              </p>
              <p>＜個人情報に関するお問い合わせ先＞</p>
              <p className="mb-8">メールアドレス:official@masentic.com</p>
            </DocumentContentSection>

            <DocumentContentSection title="7. クッキーおよびトラッキング技術">
              <p className="mb-8">
                当社は、サービスの品質向上および利用状況の分析のため、第三者の分析ツールを使用することがあります。これらのツールは、匿名化されたデータのみを扱い、個人を特定する情報は取得しません。当社は、収集した情報を第三者に販売することはありません。
              </p>
            </DocumentContentSection>

            <DocumentContentSection title="8. 法令・規範の遵守に関する事項">
              <p className="mb-8">
                個人情報の取扱いに関しては、個人情報保護に関する日本の法令・国が定める指針、その他の規範を遵守します。
              </p>
            </DocumentContentSection>

            <DocumentContentSection title="9. お問い合わせ">
              <p className="mb-6">
                本プライバシーポリシーについてご質問がある場合や、個人情報の取扱いに関するお問い合わせは、当社のカスタマーサポートまでご連絡ください。
              </p>
              <p>メールアドレス:official@masentic.com</p>
              <p className="mb-8">当社は、いただいたお問い合わせに対して、可能な限り迅速かつ誠実に対応いたします。</p>
            </DocumentContentSection>

            <DocumentContentSection title="10. 本ポリシーの変更手続">
              <p className="mb-6">
                当社は、必要に応じて、本ポリシーを変更します。ただし、法令上ユーザーの個別同意が必要となるような変更を行う場合、変更後の本ポリシーは、当社所定の方法で変更に同意したユーザーに対してのみ適用されるものとします。
              </p>
            </DocumentContentSection>
          </div>

          <DocumentSignature />
        </div>
      </div>
    </div>
  );
};
